import { graphql, useStaticQuery } from 'gatsby';
import React from 'react';
import AccordionInfo from '../../components/AccordionInfo/AccordionInfo';

const Faq = () => {
  const data = useStaticQuery(graphql`
    query {
      faqJson {
        title
        items {
          id
          title
          content
        }
      }
    }
  `);

  const { title, items } = data.faqJson;

  return <AccordionInfo title={title} items={items} onlyItems noPadding />;
};

export default Faq;
